import { render, staticRenderFns } from "./StepFolderMapping.vue?vue&type=template&id=0d167e31&scoped=true&"
import script from "./StepFolderMapping.vue?vue&type=script&lang=js&"
export * from "./StepFolderMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d167e31",
  null
  
)

export default component.exports